import { CORE_LINT_RULES } from './rules';
import type { LintFinding, LintRule } from './types';

/**
 * Lint an HTML composition against the determinism rules. Returns a flat list of findings; an
 * empty list means the composition passes. Pass a custom rule set to extend or replace the core
 * rules (e.g. in tests).
 */
export function lintHtmlComposition(
    html: string,
    rules: LintRule[] = CORE_LINT_RULES,
): LintFinding[] {
    const findings: LintFinding[] = [];
    for (const rule of rules) {
        for (const message of rule.check(html)) {
            findings.push({ ruleId: rule.id, severity: rule.severity, message });
        }
    }
    return findings;
}

export function hasLintErrors(findings: LintFinding[]): boolean {
    return findings.some((finding) => finding.severity === 'error');
}
